import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { TServices } from 'types/services';
import { ServicesContext } from 'contexts/ServicesContext';
import { TIntl } from 'types/i18n';
import { IntlContext } from 'contexts/IntlContext';
import { AppStoreProvider } from 'providers/appStoreProvider';
import { AppRoot } from 'containers/AppRoot';
import { ModalRoot } from 'containers/ModalPortal';
import { ThemeProviderComponent } from 'design/themeProvider';
import { ErrorBoundaryComponent } from 'utils/errorBoundary/errorBoundaryComponents';
import { AsyncBoundaryComponent } from 'utils/asyncBoundary/asyncBoundaryComponents';
import { AppErrorFallback } from 'containers/App/AppErrorFallback';
import { AppAsyncFallback } from 'containers/App/AppAsyncFallback';

type TProps = {
  intl: TIntl;
  services: TServices;
};

export const App: React.FC<TProps> = (props) => {
  const { services, intl } = props;

  return (
    <AppStoreProvider>
      <Router>
        <ServicesContext.Provider value={services}>
          <IntlContext.Provider value={intl}>
            <ThemeProviderComponent>
              <ErrorBoundaryComponent
                errorConstructorsToCatch={[Error]}
                fallbackComponent={AppErrorFallback}
              >
                <AsyncBoundaryComponent fallback={<AppAsyncFallback />}>
                  <AppRoot />
                  <ModalRoot />
                </AsyncBoundaryComponent>
              </ErrorBoundaryComponent>
            </ThemeProviderComponent>
          </IntlContext.Provider>
        </ServicesContext.Provider>
      </Router>
    </AppStoreProvider>
  );
};
